import { NaniumObject, RequestType, Type } from 'nanium/objects';
import { ServiceRequestBase } from '../../serviceRequestBase';

export class AnalyticsPageViewCreateRequestBody extends NaniumObject<AnalyticsPageViewCreateRequestBody> {
	@Type(String) path: string;
	@Type(String) source: string;
	@Type(String) platform: string;
	@Type(String) visitorId: string;
}

@RequestType({
	responseType: Boolean,
	genericTypes: { TRequestBody: AnalyticsPageViewCreateRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class AnalyticsPageViewCreateRequest extends ServiceRequestBase<AnalyticsPageViewCreateRequestBody, Boolean> {
	static serviceName: string = 'NaniumDemo:analytics/pageView/create';
}
